import { render, staticRenderFns } from "./FormOtherSituation.vue?vue&type=template&id=2ceaae22"
import script from "./FormOtherSituation.vue?vue&type=script&lang=js"
export * from "./FormOtherSituation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports